<script setup lang="ts">
/***
 * template to show object fields as key-value pairs in two columns
 */
const _props = defineProps<DataTableCellProps>();

import type { DataTableCellProps } from './templateTypes';
</script>

<template>
  <InternalLink class="a-inline" :to="`/operatingcostinvoices/${cell.meta('rawvalue').id}`">
    {{ cell.meta('rawvalue').issuerLegalName }}
  </InternalLink>
</template>
